import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CountryCodes } from '../../../consts/countryCode';

@Component({
  selector: 'app-country-flag',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <!-- Drapeau belge -->
    <ng-container *ngIf="countryName === 'Belgium'">
      <div [style]="belgiumFlagStyle"></div>
    </ng-container>

    <!-- Drapeau suisse -->
    <ng-container *ngIf="countryName === 'Switzerland'">
      <div [style]="switzerlandFlagStyle">
        <div [style]="switzerlandCrossStyle"></div>
      </div>
    </ng-container>

    <!-- Drapeau portugais -->
    <ng-container *ngIf="countryName === 'Portugal'">
      <div [style]="portugalFlagStyle">
        <div [style]="portugalEmblemStyle"></div>
      </div>
    </ng-container>

    <!-- Drapeau allemand -->
    <ng-container *ngIf="countryName === 'Germany'">
      <div [style]="germanyFlagStyle"></div>
    </ng-container>

    <!-- Autres drapeaux via mat-icon -->
    <ng-container *ngIf="countryName !== 'Belgium' && countryName !== 'Switzerland' && countryName !== 'Portugal' && countryName !== 'Germany'">
      <mat-icon [svgIcon]="getCountryCode(countryName)"></mat-icon>
    </ng-container>
  `,
  styleUrls: ['./country-flag.component.scss']
})
export class CountryFlagComponent {
  @Input() countryName: string = '';
  @Input() inDropdown: boolean = false;

  get belgiumFlagStyle(): string {
    const baseStyle = 'display: inline-block; width: 24px; height: 16px; background: linear-gradient(to right, #000000 0%, #000000 33.33%, #FDDA24 33.33%, #FDDA24 66.66%, #EF3340 66.66%, #EF3340 100%); border-radius: 1px;';
    return this.inDropdown ? baseStyle + ' vertical-align: middle; margin-right: 8px;' : baseStyle;
  }

  get switzerlandFlagStyle(): string {
    const baseStyle = 'display: inline-block; width: 24px; height: 16px; background-color: #FF0000; border-radius: 1px; position: relative;';
    return this.inDropdown ? baseStyle + ' vertical-align: middle; margin-right: 8px;' : baseStyle;
  }

  get switzerlandCrossStyle(): string {
    return 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 8px; height: 8px; background-color: white; clip-path: polygon(0% 33.33%, 33.33% 33.33%, 33.33% 0%, 66.66% 0%, 66.66% 33.33%, 100% 33.33%, 100% 66.66%, 66.66% 66.66%, 66.66% 100%, 33.33% 100%, 33.33% 66.66%, 0% 66.66%);';
  }

  get portugalFlagStyle(): string {
    const baseStyle = 'display: inline-block; width: 24px; height: 16px; background: linear-gradient(to right, #006600 0%, #006600 33.33%, #FF0000 33.33%, #FF0000 100%); border-radius: 1px; position: relative;';
    return this.inDropdown ? baseStyle + ' vertical-align: middle; margin-right: 8px;' : baseStyle;
  }

  get portugalEmblemStyle(): string {
    return 'position: absolute; top: 50%; left: 30%; transform: translate(-50%, -50%); width: 6px; height: 6px; background-color: #FFF000; border-radius: 50%; border: 1px solid #000;';
  }

  get germanyFlagStyle(): string {
    const baseStyle = 'display: inline-block; width: 24px; height: 16px; background: linear-gradient(to bottom, #000000 0%, #000000 33.33%, #DD0000 33.33%, #DD0000 66.66%, #FFCE00 66.66%, #FFCE00 100%); border-radius: 1px;';
    return this.inDropdown ? baseStyle + ' vertical-align: middle; margin-right: 8px;' : baseStyle;
  }

  getCountryCode(countryName: string): string | undefined {
    return CountryCodes[countryName];
  }
}
